import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { sensaiProgressBar_template } from "./sensaiProgressBar_template";
declare var ko: any;

export class genericPrompt_template extends vnTemplate{
    protected sensaiProgressBar :sensaiProgressBar_template;
    protected getTemplateHtml(): string{
        return /* html */`
        <div data-bind="css: { 'is-visible': show}" class="w-lightbox light-theme" >
            <div class="lightbox-content" >
                <div class="w-form lightbox-form best-practice" id="generic-prompt">
                <form data-bind="submit: validateForm">
                    <div class="form-header">
                        <h3 class="form-title" data-bind="text: title"></h3>
                        <button  data-bind="visible: declineText, event: { click: onClickDecline }" class="close-button icon i-close-2" type="button"></button>
                    </div>

                    <div class="form-body">
                        <div class="w-guidelines">
                        <!-- ko if: showWarning() -->
                            <div class="sensai-warning">
                                <span class="alert-icon">⚠️</span>
                                <div class="alert-content">
                                    <h3 class="alert-title">Warning</h3>
                                    <p>This article is missing basic elements or points of coverage that could help improve its overall content value. Review the guidelines below or visit the feedback tab for suggestions.</p>
                                </div>
                            </div>
                        <!-- /ko -->
                        
                        ${this.sensaiProgressBar.getHtmlBuild()}
                        
                        <div class="form-pagination">
                            <button class="btn icon i-article-list" type="button" data-bind="event: { click: onClickTab.bind($data,'guidelines') }, css: { 'is-activated' : selectedTab() == 'guidelines'}"><span class="btn-text">Content GuideLines</span></button>
                             
                            <button class="btn icon i-topics" type="button" data-bind="event: { click: onClickTab.bind($data,'suggestions') }, css: { 'is-activated' : selectedTab() == 'suggestions'}"><span class="btn-text">Content Suggestions</span></button>
                            
                        </div>
                            <!-- ko if: promptType() == 'sensaiPrompt'-->
                                <div class="form-group guidelines-popup" data-bind="style: { display: selectedTab() === 'guidelines' ? 'block' : 'none' }">

                                    <div>

                                   <!-- ko if: content().length < 1 && selectedTab() == 'guidelines' -->
                                        <span class="notification-message" style="margin: 2rem 0; display:block;">There are no content guidelines for the selected Content Type. Please refer to your managing editor for best practices.

                                        </span>
                                    <!-- /ko -->
                                        <ul class="emaki-card-parent-list" data-bind="foreach: content">
                                            <li class="emaki-card">
                                                <span class="emaki-card-title" data-bind="text: $data.sectionName"></span>
                                                    <ul class="emaki-card-list">
                                                    <!-- ko foreach: $data.rules -->
                                                        <li class="emaki-card-item" data-bind="css: { 'mandatory': isMandatory, 'rejected': !ruleStatus, 'approved': ruleStatus }">
                                                            <span class="icon" data-bind="text: ruleName"></span>
                                                            <span class="icon"></span>
                                                        </li>
                                                    <!-- /ko -->
                                                    <!-- <li class="emaki-card-item approved"><span class="icon">SEO description</span><span class="icon"></span></li>
                                                        <li class="emaki-card-item approved mandatory"><span class="icon">SEO description</span><span class="icon"></span></li> -->

                                                    </ul>
                                            </li>
                                        </ul>
                                    </div>

                                </div>
                                

                                    <!-- ko if: subjectCoverage().length <= 0 && selectedTab() == 'suggestions'-->
                                    <div class="form-group" style="margin: 3rem 2rem 1rem;">
                                        <span class="notification-message">There are no content suggestions available. Visit the feedback tab to generate some</span>
                                    </div>
                                    <!-- /ko -->
                                    <div class = "form-group guidelines-popup" data-bind="style: { display: selectedTab() === 'suggestions' ? 'block' : 'none' }">
                                        <table class="list-results" style="margin: 2rem 0;">
                                            <thead>
                                                <th><span >Suggestions</span></th>
                                                <th><span >Coverage Score</span></th>
                                                <th><span class="i-sensai-icon">Feedback</span></th>
                                            </thead>
                                            <tbody data-bind="foreach: subjectCoverage">
                                                <tr class="cursor">
                                                    <td><span class="score-indicator" data-bind="style: {
                                                        'background-color': similarityScore === null || similarityScore === '' ? '' :
                                                        similarityScore >= 0.75 ? '#b9ddc1' :
                                                        (similarityScore >= 0.5 ? '#f3e09d' : '#fcb4bb')
                                                        }">
                                                        </span>
                                                        <span data-bind="text: suggestionText, style: { 'font-weight': similarityScore !== null && similarityScore !== '' && similarityScore <= 0.5 ? 'bold' : 'normal' }"></span>
                                                    </td>
                                                    <td><span class="feedback-score" style="position: static;" data-bind="attr: { id: 'row-' + id }, text: similarityScore !== null && similarityScore !== '' ? (similarityScore >= 0.75 ? 'Covered' : (similarityScore >= 0.5 ? 'Somewhat Covered' : 'Not Covered')) : '',
                                                    css: {
                                                    'positive-feedback': similarityScore !== null && similarityScore !== '' && similarityScore >= 0.75,
                                                    'regular-feedback': similarityScore !== null && similarityScore !== '' && similarityScore >= 0.5 && similarityScore < 0.75,
                                                    'negative-feedback': similarityScore !== null && similarityScore !== '' && similarityScore < 0.5
                                                    }">
                                                    </span>
                                                    </td>
                                                    <td><span data-bind="text: reliabilityFeedback"></span></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                <!-- /ko -->


                        </div>

                        <!-- ko if: promptType() == 'genericPrompt' -->
                            <div class="form-group guidelines-popup" data-bind="html: content">
                            </div>
                        <!-- /ko -->

                        <!-- ko if: commentsRequired() -->
                            <div class="form-group inside-label">
                            <label for="genericPromptComment" class="form-label">
                            Comments
                            <!-- ko if: idStatus() !== 6 -->
                                <span>(required)</span>
                            <!-- /ko -->
                        </label>
                                <textarea name="genericPromptComment" data-bind="value: comments" required></textarea>
                            </div>
                        <!-- /ko -->
                    </div>

                    <div class="form-footer">
                        <button type="button" data-bind="visible: declineText, event: { click: onClickDecline }, text: declineText" class="btn "></button>
                        <button type="button" data-bind="visible: acceptText, event: { click: onClickAgree }, text: acceptText" class="btn highlight"></button>
                    </div>

<!--                    <button type="button" class="close-btn icon i-close" data-bind="visible: isCancellable(), event: { click: onClickCancel }"></button>-->
                    </form>
                </div>
            </div>
        </div>
        `;

    }
    protected initPartial():void{
        this.sensaiProgressBar = new sensaiProgressBar_template('sensaiProgressBar', this.getTemplateViewModel(), this.caller);
    }
    protected getTemplateName(): string{
        return "generic-prompt-template";
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected buildViewModel(): any{

        let huit_neuf_this = this;
        let viewModel = {
            title: ko.observableArray(''),
            content: ko.observable([]),
            totalSensaiScore: ko.observable(null),
            contentGuidelineScore: ko.observable(null),
            sensaiCoverageScore: ko.observable(null),
            subjectCoverage: ko.observableArray([]),
            sensaiRulePointThreshold: ko.observable(null),
            acceptText: ko.observable(''),
            idBrand: ko.observable(this.caller.getVnAppZone().app.params.idBrand),
            declineText: ko.observable(''),
            agree: ko.observable(null),
            decline: ko.observable(null),
            selectedTab: ko.observable('guidelines'),
            promptType: ko.observable('genericPrompt'),
            show: ko.observable(false),
            isCancellable: ko.observable(false),
            commentsRequired: ko.observable(false),
            comments: ko.observable(''),
            saveType: ko.observable(''),
            groupOrder: ko.observableArray(["MetaData","Images","Linking","ContentStructureAndFormatting","EnhancedExperienceFeatures"]),
            isFormValid: ko.observable(true),
            idStatus: ko.observable(0),
            showWarning: ko.observable(false),
            validateForm: function () {
                viewModel.isFormValid(viewModel.commentsRequired() ? viewModel.comments().trim() !== '' : true);
            },
            onClickAgree: function (data, event) {
                huit_neuf_this.onClickAgree();
            },
            onClickDecline: function (data, event) {
                huit_neuf_this.onClickDecline();
            },
            onClickCancel: function (data, event) {
                huit_neuf_this.onClickCancel();
            },
            onClickTab: function (value, data, event) {
                huit_neuf_this.onClickTab(value);
            },
        };

        return viewModel;
    }

    public setTitle(title: string){
        this.getTemplateViewModel().title(title);
    }

    public setContent(content: any){
        if(this.getTemplateViewModel().promptType() == 'sensaiPrompt' && content){

            let order = this.getTemplateViewModel().groupOrder().map(item => item.toLowerCase().replace(/\s/g, ''));

            content.sort((a, b) => {
                let sectionNameA = a.sectionName.toLowerCase().replace(/\s/g, '');
                let sectionNameB = b.sectionName.toLowerCase().replace(/\s/g, '');

                let indexA = order.indexOf(sectionNameA);
                let indexB = order.indexOf(sectionNameB);

                // If a sectionName is not found in the order, it will get a default high index
                if (indexA === -1) indexA = order.length;
                if (indexB === -1) indexB = order.length;

                return indexA - indexB;
            });
        }
        this.getTemplateViewModel().content(content);
    }

    public setAcceptText(text: string){
        this.getTemplateViewModel().acceptText(text);
    }

    public setDeclineText(text: string){
        this.getTemplateViewModel().declineText(text);
    }

    public setIsCancellable(isCancellable: boolean){
        this.getTemplateViewModel().isCancellable(isCancellable);
    }

    public setCommentsRequired(commentsRequired: boolean){
        this.getTemplateViewModel().commentsRequired(commentsRequired);
    }

    public setComments(comments: string){
        this.getTemplateViewModel().comments(comments);
    }

    public setAgree(agree: any){
        this.getTemplateViewModel().agree(agree);
    }

    public setSaveType(saveType: string){
        this.getTemplateViewModel().saveType(saveType);
    }

    public setDecline(decline: any){
        this.getTemplateViewModel().decline(decline);
    }

    public setPromptType(promptType: string){
        this.getTemplateViewModel().promptType(promptType);
    }

    public setTotalSensaiScore(totalSensaiScore){
        // let coverageScore  = this.getTemplateViewModel().sensaiCoverageScore();
        // let guidelineScore = this.getTemplateViewModel().contentGuidelineScore();

        // this.getTemplateViewModel().totalSensaiScore((parseFloat(coverageScore) + parseFloat(guidelineScore)).toFixed(2));
        this.getTemplateViewModel().totalSensaiScore(totalSensaiScore);
        this.sensaiProgressBar.setScore(totalSensaiScore, this.getTemplateViewModel().sensaiRulePointThreshold());
    }

    public getTotalSensaiScore() :number
    {
        return this.getTemplateViewModel().totalSensaiScore();
    }

    public getPromptType(): string {
        return this.getTemplateViewModel().promptType();
    }

    public setShow(show: boolean){
        this.getTemplateViewModel().show(show);
    }

    public getShow(): boolean {
        return this.getTemplateViewModel().show();
    }
    public setIdStatus(idStatus: number){
        this.getTemplateViewModel().idStatus(idStatus);
    }

    public getIdStatus(): number {
        return this.getTemplateViewModel().idStatus();
    }
    protected onClickAgree() {
        this.getTemplateViewModel().validateForm();

        if((this.getTemplateViewModel().totalSensaiScore() <= this.getTemplateViewModel().sensaiRulePointThreshold())
            && !this.getTemplateViewModel().showWarning()            
         ){
            this.getTemplateViewModel().showWarning(true);
            return ;
        }

        if (this.getTemplateViewModel().isFormValid() || this.getIdStatus() == 6) {
            let agreeFunction = this.getTemplateViewModel().agree();
            if (typeof agreeFunction === 'function') {
                agreeFunction(this.getTemplateViewModel().comments(), this.getTemplateViewModel().saveType());
                this.getTemplateViewModel().show(false);
                this.getTemplateViewModel().selectedTab('guidelines');
            }
        }
    }

    protected onClickDecline() {
        //this.getTemplateViewModel().validateForm();
        //if (this.getTemplateViewModel().isFormValid()) {
            let declineFunction = this.getTemplateViewModel().decline();
            if (typeof declineFunction === 'function') {
                declineFunction(this.getTemplateViewModel().comments(), this.getTemplateViewModel().saveType());
                this.getTemplateViewModel().show(false);
                this.getTemplateViewModel().selectedTab('guidelines');
            }
        //}
    }

    protected onClickCancel() {

        //this.getTemplateViewModel().content(false); // just hides it because the condition is not met in the knockout js template..
        this.getTemplateViewModel().comments('');
        this.getTemplateViewModel().show(false);
    }

    public showLoading() {
        let form = document.getElementById("generic-prompt");
        form.classList.add("loading");
    }

    public removeLoading() {
        let form = document.getElementById("generic-prompt");
        form.classList.remove("loading");
    }

    public getContentGuidelineScore(): number{
        return this.getTemplateViewModel().contentGuidelineScore();
    }

    public setContentGuidelineScore(score : number){
        //let aiScore = this.getTemplateViewModel().totalSensaiScore();
        //this.getTemplateViewModel().totalSensaiScore(aiScore+score);
        this.getTemplateViewModel().contentGuidelineScore(score);
        //this.sensaiProgressBar.setScore(aiScore+score);
    }

    public setSensaiCoverageScore(score : number){

        this.getTemplateViewModel().sensaiCoverageScore(score);
    }

    public getSensaiCoverageScore(): number{
        return this.getTemplateViewModel().sensaiCoverageScore();
    }

    protected onClickTab(tab) {
        if (tab == 'suggestions') {
            // if(this.getTemplateViewModel().subjectCoverage().length <= 0) {

            // }
            this.caller.getAIContent(false,true);
            this.getTemplateViewModel().selectedTab('suggestions');
        }
        if (tab == 'guidelines' && this.getTemplateViewModel().content().length > 0) {

            //this.caller.getAIContent(false,true);
            this.getTemplateViewModel().selectedTab('guidelines');
        }
    }

    public setSubjectCoverage(subjectCoverage) {
        this.getTemplateViewModel().subjectCoverage([]);
        this.getTemplateViewModel().subjectCoverage(subjectCoverage);
    }

    public setSensaiRulePointThreshold(threshold){
        this.getTemplateViewModel().sensaiRulePointThreshold(threshold);
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/genericPrompt_template.ts